import React from 'react';
import {
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import {
  CoreLink,
} from '@uncinc/react-drupal-core';

import { useTranslation } from 'react-i18next';

import './style.scss';

const ParagraphCtaBlock = ({ entity }) => {
  const { t } = useTranslation();
  const title = entity.getIn(['field_title', 0, 'value'], '');
  const text = entity.getIn(['field_text', 0, 'processed']);
  const linkUrl = entity.getIn(['field_link', 0, 'alias'], entity.getIn(['field_link', 0, 'uri']));
  const linkTitle = entity.getIn(['field_link', 0, 'title'], '');

  function isFile(pathname) {
    return pathname.split('/').pop().indexOf('.') > -1;
  }

  return (
    <div className="ParagraphCtaBlock col-12 col-lg-6 ">

      <div className="ParagraphCtaBlock__inner">
        <div className="ParagraphCtaBlock__inner__title">
          <h2>{title}</h2>
        </div>
        <div className="ParagraphCtaBlock__inner__content">
          <div className="ParagraphCtaBlock__inner__text">
            <WysiwygField
              property="schema:text"
              html={text}
            />
          </div>

          <div className="ParagraphCtaBlock__inner__link">
            {linkUrl && (
              (isFile(linkUrl) ? (
                <a target="_blank" rel="noreferrer" className="Button Button--primary Button--block" href={linkUrl}>
                  {linkTitle === '' ? t('general.readMore') : linkTitle} <i className="icon icon-arrow-right icon-variant-2" />
                </a>
              ) : (
                <CoreLink className="Button Button--primary Button--block" to={linkUrl}>
                  {linkTitle === '' ? t('general.readMore') : linkTitle} <i className="icon icon-arrow-right icon-variant-2" />
                </CoreLink>
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ParagraphCtaBlock;
